import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";

export default class Navbar extends Component {
  componentDidMount() {
    $(".nav-control").on('click', function() {
      $('#main-wrapper').toggleClass("menu-toggle");
      $(".hamburger").toggleClass("is-active");
    });
  }

  componentWillUnmount() {
    $(".nav-control").off('click');
  }

  render() {
    return (
      <>
        <div className="nav-header">
          <Link to="/agent" className="brand-logo">
            <img
              src="/dpworld.png"
              className="brand-title"
              alt=""
            />
          </Link>
          
        </div>
        <div id="main-wrapper">
          {/* Add your main content here */}
        </div>
      </>
    );
  }
}
